export const trans_3_1=[
  {
    id:1,
    english:'What is your job? I am working as an accountant',
    vietnamese:'Bạn làm nghề gì? Tôi là toàn viên',
    user_message:''
  },
  {
    id:2,
    english:'What is her job? She works as a nurse',
    vietnamese:'Cô ấy làm nghề gì? Cô ấy là y tá',
    user_message:''
  },
  {
    id:3,
    english:'What is their job? They are travel company staff',
    vietnamese:'Hộ làm nghề gì? Họ là nhân viên công ty du lịch',
    user_message:''
  },
  {
    id:4,
    english:'What job do you like? I like to become a doctor',
    vietnamese:'Bạn tích làm nghề gì? Tôi muốn trở thành một bác sỹ',
    user_message:''
  }, 
]

export const trans_3_2=[
  {
    id:1,
    english:'Hello. I am an engineer',
    vietnamese:'Chào anh. Em là kỹ sư',
    user_message:''
  },
  {
    id:2,
    english:'Sorry, I want to see doctor',
    vietnamese:'Xin lỗi, tôi muốn gặp bác sĩ',
    user_message:''
  },
  {
    id:3,
    english:' Excuse me, which company are you working for?',
    vietnamese:'Xin lỗi, bạn đang làm ở công ty nào?',
    user_message:''
  },
  {
    id:4,
    english:'I am Lan. I am a first year student',
    vietnamese:'Em là Làm. Em đang là sinh viên năm thứ nhất',
    user_message:''
  },
]